// src/lib/partnerConversion.js
//
// dataLayer conversion signals for the /for-partners paid campaign, mirroring
// purchaseComplete's single-fire/dedupe pattern. No PII — just the account
// reference and the event name.
//
//   partner_signup      — PRIMARY conversion (a firm created a self-serve
//                         account). This is what the campaign optimises to.
//                         Deduped on the account reference.
//   partner_talk_to_us  — SECONDARY conversion (the "Talk to us" enquiry form).
//                         Tracked, but NOT the primary optimisation target.

// Fire the primary partner_signup conversion at most once per account reference.
// Guard is a sessionStorage flag so a refresh / re-render never double-fires.
export function pushPartnerSignup(reference) {
  if (!reference || typeof window === 'undefined') return false;
  const guardKey = `partner_signup_${reference}`;
  try {
    if (window.sessionStorage && window.sessionStorage.getItem(guardKey)) return false;
  } catch {
    // sessionStorage can throw (private mode) — fall through and push.
  }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'partner_signup',
    product_family: 'partner_signup',
    account_reference: reference,
  });
  try { window.sessionStorage?.setItem(guardKey, 'true'); } catch { /* ignore */ }
  return true;
}

// Fire the secondary "talk to us" enquiry event. Lower priority than signup, so
// it's a distinct event GTM maps to a non-primary conversion. Deduped once per
// tab so a double-submit doesn't double-count.
export function pushPartnerTalkToUs() {
  if (typeof window === 'undefined') return false;
  const guardKey = 'partner_talk_to_us_fired';
  try {
    if (window.sessionStorage && window.sessionStorage.getItem(guardKey)) return false;
  } catch { /* fall through */ }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: 'partner_talk_to_us', product_family: 'partner_lead' });
  try { window.sessionStorage?.setItem(guardKey, 'true'); } catch { /* ignore */ }
  return true;
}
